class ReturnTabs extends HTMLElement {
  constructor() {
    super();
    let tabHeads = this.querySelectorAll('[data-step-tab-head]');
    let tabContents = this.querySelectorAll('[data-step-tab-body]');
    tabHeads.forEach(function (tabHead) {
      tabHead.addEventListener('click', function () {
        let tabStep = tabHead.getAttribute('data-step-tab-head');
        tabHeads.forEach(function (th) {
          th.classList.remove('return__tabs-step-item--active');
        });
        tabHead.classList.add('return__tabs-step-item--active');
        tabContents.forEach(function (tabContent) {
          let contentStep = tabContent.getAttribute('data-step-tab-body');
          if (contentStep === tabStep) {
            tabContent.classList.add('return__tabs-step-content-item--active');
          } else {
            tabContent.classList.remove('return__tabs-step-content-item--active');
          }
        });
      });
    });
  }
}

customElements.define('return-tabs', ReturnTabs);